import { render, staticRenderFns } from "./Authorisation.vue?vue&type=template&id=7bb73ca2&scoped=true"
import script from "./Authorisation.vue?vue&type=script&lang=ts"
export * from "./Authorisation.vue?vue&type=script&lang=ts"
import style0 from "./Authorisation.vue?vue&type=style&index=0&id=7bb73ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb73ca2",
  null
  
)

export default component.exports